// Pure helpers for LeadProfile — no React imports, easy to unit-test.

export function calcMonthly(amount, ratePct, termMonths) {
  if (!amount || !ratePct || !termMonths) return 0;
  const r = ratePct / 100 / 12;
  return (amount * r) / (1 - Math.pow(1 + r, -termMonths));
}

export function money(n) {
  if (!Number.isFinite(n)) return '$0';
  return '$' + Math.round(n).toLocaleString();
}

// Empty-by-default 1003 form. Anything not explicitly populated by the user, the AI
// extractor, or pulled from the lead record stays blank — never seeded with placeholder
// values. This is critical to prevent the "lead opens with bogus data" UX bug.
export function buildInitial(lead) {
  if (!lead) return {};
  const [first, ...rest] = (lead.name || '').split(' ');
  return {
    firstName: first || '', middleName: '', lastName: rest.join(' ') || '', suffix: '',
    dob: '', ssn: '', marital: '', dependents: 0, citizenship: '',
    email: lead.email || '', phone: lead.phone || '',
    currentAddress: '', currentUnit: '', currentCity: '', currentState: '', currentCounty: '', currentZip: '',
    yearsAtAddress: 0, monthsAtAddress: 0,
    prevAddress: '',
    livingSituation: '',
    employer: '', position: '', employmentType: '', employmentStart: '',
    monthlyBaseIncome: 0, monthlyOvertime: 0, monthlyBonus: 0, monthlyCommission: 0, monthlyOther: 0,
    otherIncomeSource: '',
    assets: [],
    creditScore: 0, creditPulled: '', creditBureau: '', monthlyDebts: 0,
    declarations: {},
    propertyAddress: '', propertyUnit: '', propertyCity: '', propertyState: '', propertyCounty: '', propertyZip: '',
    propertyType: '', occupancy: '',
    propertyValue: 0, purchasePrice: 0, hoa: 0, taxes: 0, insurance: 0,
    loanAmount: lead.estAmount || 0,
    loanType: '', loanPurpose: '', loanTerm: 0, rate: 0, lockStatus: '', lockExpiration: '',
    lender: '', loanDate: '',
  };
}

// Per-section completion percentages — drives the gold pill chips on each tab.
export function sectionCompletion(d) {
  const need = (...vals) => vals.filter((v) => v !== undefined && v !== null && v !== '' && v !== 0).length;
  return {
    profile: Math.round((need(d.firstName, d.lastName, d.email, d.phone, d.currentAddress, d.marital, d.citizenship) / 7) * 100),
    employment: Math.round((need(d.employer, d.position, d.employmentType, d.employmentStart, d.monthlyBaseIncome) / 5) * 100),
    assets: d.assets && d.assets.length > 0 ? 100 : 0,
    // Credit & Liabilities is 100% as soon as DOB + SSN are captured — the
    // LO can pull credit and add liabilities later, but the application is
    // not blocked on those for tab completion.
    liabilities: Math.round((need(d.dob, d.ssn) / 2) * 100),
    property: Math.round((need(d.propertyAddress, d.propertyType, d.occupancy, d.propertyValue) / 4) * 100),
    loan: Math.round((need(d.loanType, d.loanPurpose, d.loanAmount, d.loanTerm, d.rate) / 5) * 100),
    declarations: d.declarations ? Math.round((Object.values(d.declarations).filter((v) => v !== undefined).length / 7) * 100) : 0,
    notes: 100,
  };
}
